@if (possuiErro()) {
  <div class="text-center">
    <h2 class="mt-3">Alguns documentos não foram validados</h2>
  </div>
  <div class="panel">
    <div class="panel-header">
      <div>
        <i class="las la-exclamation-circle"></i>
        Por favor reenvie os documentos abaixo
      </div>
    </div>      
    <div class="panel-content">
      <p>Não foi possível validar as informações de 1 ou mais documentos enviados, isso pode ocorrer porque a imagem/foto possui informações 
        ilegíveis o documento não é correspondente ao dependente ou por não conseguirmos garantir o vínculo familiar com o titular.</p>
      <p>Por favor, tente o seguinte:</p>
      <ul>
        <li>Tire uma nova foto do documento, garantindo que as informações estão legíveis e nítidas</li>
        <li>Confirme que se trata do documento correto do seu dependente</li>
      </ul>
      <p>Caso o erro persista, entre em contato com o seu RH ou o atendimento da Vivest.</p>
    </div>
  </div>
} @else {
<div class="text-center">
  <app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
  <h2 class="mt-3">Anexe os documentos necessários</h2>
</div>
}
<div class="d-flex container-docs align-items-center flex-column top-32">

  <div class="docs-types">Formatos aceitos: <span>.PDF, .PNG, .JPG, .JPEG</span></div>
  <div class="list-docs">
    <!-- Já enviado (processed): card travado e em análise. -->
    @if (carregado()) {
      @for (doc of documentos(); track doc.tipoDocumento) {
        <app-upload-doc-modal
          [documento]="doc"
          [processed]="doc.travado"
          [withError]="doc.erro"
          [tamanhoMaximo]="5"
          (saveDoc)="onArquivoDocumento($event)">
        </app-upload-doc-modal>
      }
    }
  </div>
</div>

<div class="d-flex justify-content-center align-items-center buttons top-64">
  @if (mostrarVoltar()) {
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
  }
  <vivest-button variant="primary" size="md" [disabled]="!podeContinuar()" (click)="onSubmit()">
    <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
    {{ possuiErro() ? 'Reenviar documentos' : 'Continuar para resumo' }}
  </vivest-button>
</div>

<vivest-modal 
  heading="Importante!"
  [hasIcon]="false"
  [open]="enviando()"
  position="top"
  (vivest-close)="closeModal()"
>
  <!-- O vivest-modal só exibe conteúdo nos slots icon, heading, description e actions. -->
  <div slot="description">
    <img src="assets/images/animacao-doc.gif" alt="">
    <p class="mb-0 text-start">Aguarde, os seus documentos estão sendo enviados.</p>
  </div>
</vivest-modal>